import { ILang } from '@/entities/feed-block/model/types'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface II18n {
  action: {
    save: string
    connect: string
  }
  app_setup: {
    title: string
    description: string
    set_default_url: string
  }
}

interface ILangStore {
  lang: ILang
  setLang: (state: string) => void
  langPack: (key: string) => string
  i18n: Record<string, II18n> // Кастомные переводы
  setI18n: (state: Record<string, II18n>) => void
  i18nDefault: Record<string, II18n> // Дефолтные переводы
  setI18nDefault: (state: Record<string, II18n>) => void
}

const getNestedValue = (
  object: Record<string, any>,
  path: string,
  defaultValue?: string
): string | undefined => {
  const result = path.split('.').reduce((acc, key) => {
    if (acc && typeof acc === 'object' && key in acc) {
      return acc[key]
    }
    return undefined
  }, object)

  return result !== undefined ? result : defaultValue
}

export const LangStore = create<ILangStore>()(
  persist(
    (set, get) => ({
      lang: 'en', // Дефолтный язык
      setLang: (lang) => set({ lang }),
      i18n: {},
      setI18n: (i18n) => set({ i18n }),
      i18nDefault: {},
      setI18nDefault: (i18nDefault) => set({ i18nDefault }),

      langPack: (key: string) => {
        const { lang, i18n, i18nDefault } = get()
        
        const customTranslation = getNestedValue(i18n[lang] || i18n['en'], key)
        if (customTranslation !== undefined) {
          return customTranslation
        }

		const defaultTranslation = getNestedValue(i18nDefault[lang] || i18nDefault['en'], key)
        if (defaultTranslation !== undefined) {
          return defaultTranslation
        }

        return key
      }
    }),
    {
      name: 'lang-storage',
      partialize: (state) => ({ lang: state.lang }),
      migrate: (persistedState, version) => {
        if (version === 0) {
          // Миграция из старой версии
        }
        return persistedState as ILangStore
      }
    }
  )
)